import { ReactNode } from 'react';

import { Box } from '@mui/material';
import { clsx } from 'clsx';
import { useBreakpoints } from 'hooks';

import styles from './CardsGrid.module.scss';

interface ICardsGridProps {
  children: ReactNode | ReactNode[];
  className?: string;
}

export const CardsGrid: React.FC<ICardsGridProps> = ({ children, className }) => {
  const { isMobile } = useBreakpoints();
  if (isMobile) return <Box className={styles.gridContainer}>{children}</Box>;
  
  if (!Array.isArray(children)) return <Box>{children}</Box>;
  
  const normalizedChildren = children.filter(Boolean);

  return (
    <Box className={clsx(styles.gridContainer, className)}>
      {normalizedChildren.map((CardComponent, index, arr) => {
        if ((arr.length & 1) === 1 && arr.length >= 3 && arr.slice(-3).includes(CardComponent))
          return (
            <Box className={clsx(styles.gridItem, styles.takeOneThird)} key={index}>
              {CardComponent}
            </Box>
          );

        return (
          <Box className={clsx(styles.gridItem, styles.takeHalf)} key={index}>
            {CardComponent}
          </Box>
        );
      })}
    </Box>
  );
};
